/* DCSBAY — Launch story: scroll reveal + light parallax. No libraries. */
(function () {
  'use strict';
  if (window.DcsbayStory) return;

  var instances = new WeakMap();

  function reduced() {
    return window.matchMedia && window.matchMedia('(prefers-reduced-motion: reduce)').matches;
  }

  function Story(root) {
    var self = this;
    this.root = root;
    this.enabled = root.getAttribute('data-animations') !== 'false' && !reduced();
    this.parallax = [];
    this.ticking = false;

    var reveals = Array.prototype.slice.call(root.querySelectorAll('[data-reveal]'));

    if (!this.enabled || !('IntersectionObserver' in window)) {
      reveals.forEach(function (el) { el.classList.add('is-in'); });
      return;
    }

    reveals.forEach(function (el) {
      var d = el.getAttribute('data-reveal-delay');
      if (d) el.style.setProperty('--ls-delay', d);
    });

    this.observer = new IntersectionObserver(function (entries) {
      entries.forEach(function (entry) {
        if (!entry.isIntersecting) return;
        entry.target.classList.add('is-in');
        self.observer.unobserve(entry.target);
      });
    }, { rootMargin: '0px 0px -8% 0px', threshold: 0.12 });

    reveals.forEach(function (el) { self.observer.observe(el); });

    this.parallax = Array.prototype.slice.call(root.querySelectorAll('[data-parallax]'));
    if (this.parallax.length) {
      this.onScroll = function () {
        if (self.ticking) return;
        self.ticking = true;
        window.requestAnimationFrame(function () { self.moveParallax(); self.ticking = false; });
      };
      window.addEventListener('scroll', this.onScroll, { passive: true });
      window.addEventListener('resize', this.onScroll, { passive: true });
      this.moveParallax();
    }
  }

  Story.prototype.moveParallax = function () {
    var vh = window.innerHeight || 1;
    this.parallax.forEach(function (el) {
      var rect = el.getBoundingClientRect();
      if (rect.bottom < -200 || rect.top > vh + 200) return;
      var factor = parseFloat(el.getAttribute('data-parallax')) || 0;
      var progress = (rect.top + rect.height / 2 - vh / 2) / vh;
      el.style.transform = 'translate3d(0,' + (progress * factor * 100).toFixed(2) + 'px,0)';
    });
  };

  Story.prototype.destroy = function () {
    if (this.observer) this.observer.disconnect();
    if (this.onScroll) {
      window.removeEventListener('scroll', this.onScroll);
      window.removeEventListener('resize', this.onScroll);
    }
  };

  function init(scope) {
    Array.prototype.forEach.call((scope || document).querySelectorAll('[data-dcsbay-story]'), function (root) {
      if (instances.has(root)) return;
      instances.set(root, new Story(root));
    });
  }

  function destroy(scope) {
    Array.prototype.forEach.call((scope || document).querySelectorAll('[data-dcsbay-story]'), function (root) {
      var inst = instances.get(root);
      if (inst) { inst.destroy(); instances.delete(root); }
    });
  }

  window.DcsbayStory = { init: init, destroy: destroy };

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', function () { init(); });
  } else { init(); }

  document.addEventListener('shopify:section:load', function (e) { init(e.target); });
  document.addEventListener('shopify:section:unload', function (e) { destroy(e.target); });
  document.addEventListener('shopify:block:select', function (e) {
    if (!e.target || typeof e.target.closest !== 'function') return;
    if (!e.target.closest('[data-dcsbay-story]')) return;
    Array.prototype.forEach.call(e.target.querySelectorAll('[data-reveal]'), function (el) {
      el.classList.add('is-in');
    });
    e.target.scrollIntoView({ block: 'center', behavior: reduced() ? 'auto' : 'smooth' });
  });
})();
